module.exports = __webpack_public_path__ + "img/join-17.d889b096.png";